var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVuesaxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 15V9C22 7.34 20.66 6 19 6H5C3.34 6 2 7.34 2 9V15C2 16.66 3.34 18 5 18H19C20.66 18 22 16.66 22 15Z",
    fill: "#D03838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15V9C22 7.34 20.66 6 19 6H5C3.34 6 2 7.34 2 9V15C2 16.66 3.34 18 5 18H19C20.66 18 22 16.66 22 15Z",
    fill: "#D03838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15V9C22 7.34 20.66 6 19 6H5C3.34 6 2 7.34 2 9V15C2 16.66 3.34 18 5 18H19C20.66 18 22 16.66 22 15Z",
    fill: "#D03838"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.5V9.5C21 8.11667 19.794 7 18.3 7H5.7C4.206 7 3 8.11667 3 9.5V14.5C3 15.8833 4.206 17 5.7 17H18.3C19.794 17 21 15.8833 21 14.5Z",
    fill: "#D03838"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.5V9.5C21 8.11667 19.794 7 18.3 7H5.7C4.206 7 3 8.11667 3 9.5V14.5C3 15.8833 4.206 17 5.7 17H18.3C19.794 17 21 15.8833 21 14.5Z",
    fill: "#D03838"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.5V9.5C21 8.11667 19.794 7 18.3 7H5.7C4.206 7 3 8.11667 3 9.5V14.5C3 15.8833 4.206 17 5.7 17H18.3C19.794 17 21 15.8833 21 14.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92923 19.5H18.0692C18.3892 19.5 18.6192 19.79 18.5592 20.1C18.2892 21.58 17.4192 22 15.3292 22H8.66923C6.56923 22 5.70923 21.58 5.43923 20.1C5.37923 19.79 5.60923 19.5 5.92923 19.5Z",
    fill: "#D03838"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66923 2H15.3292C17.4292 2 18.2892 2.42 18.5592 3.9C18.6192 4.21 18.3792 4.5 18.0692 4.5H5.92923C5.60923 4.5 5.37923 4.21 5.43923 3.9C5.70923 2.42 6.56923 2 8.66923 2Z",
    fill: "#D03838"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2893 15V11.063L4.24558 11.7077V10.3953L5.50419 9.51279H6.86256V15H5.2893ZM9.03028 15V14.7774L10.9489 12.7437C11.4938 12.1605 11.8545 11.6923 11.8545 11.2319C11.8545 10.8635 11.6626 10.6179 11.2712 10.6179C10.8798 10.6179 10.6342 10.8558 10.5652 11.5081H9.13772C9.19144 10.1344 10.0203 9.43605 11.348 9.43605C12.691 9.43605 13.4047 10.1574 13.4047 11.1705C13.4047 11.9226 12.9826 12.4905 12.3687 13.0814L11.6012 13.8258H13.4431V15H9.03028ZM17.7062 15.0921C16.179 15.0921 15.4653 14.386 15.4192 13.1965H16.816C16.862 13.6493 17.0769 13.9563 17.6218 13.9563C18.1053 13.9563 18.3432 13.726 18.3432 13.3347C18.3432 12.9049 18.113 12.69 17.6218 12.69H17.1844V11.7153H17.5911C18.0823 11.7153 18.3202 11.4928 18.3202 11.1091C18.3202 10.7791 18.1053 10.5642 17.6909 10.5642C17.2688 10.5642 17.0232 10.8174 16.9618 11.2626H15.5727C15.6418 10.1805 16.3632 9.43605 17.7292 9.43605C19.0185 9.43605 19.7937 10.027 19.7937 10.9402C19.7937 11.5542 19.4406 11.9533 18.865 12.1221C19.4944 12.2526 19.9318 12.6977 19.9318 13.3653C19.9318 14.4091 19.1567 15.0921 17.7062 15.0921Z",
    fill: "#D03838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxIcon);
export default __webpack_public_path__ + "static/media/vuesax-icon.48708ec7ffa6bfe908961a9094213cb8.svg";
export { ForwardRef as ReactComponent };